import axios from 'axios';

const API_URL = 'http://137.74.92.81:3098';

export interface IUserScore {
    time: number;
    level: number;
    date: number;
    id: number;
    userId: number;
}

export interface IRecordScore {
    time: number;
    level: number;
    date: number;
    id: number;
    userId: number;
    name: string;
    countryCode: string;
}

export async function getUserScores(userId: number, gameId: number): Promise<IUserScore[]> {
    const url = API_URL + '/getUserScores';
    const postData = {userId, gameId};
    const data = await axios.post(url, postData);
    return data.data as IUserScore[];
}

export async function getRecords(gameId: number): Promise<IRecordScore[]> {
    const url = API_URL + '/getBestScores';
    const data = await axios.post(url, { gameId });
    return data.data as IRecordScore[];
}